<template>
  <v-dialog
    v-model="show"
    hide-overlay
    fullscreen
    transition="dialog-bottom-transition"
  >
    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
      <v-card height="100%">
        <v-toolbar dark color="blue">
          <v-btn icon dark @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Remito de Recepción de Materiales</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-row dense>
            <v-col cols="12" sm="6" md="6">
              <h6><b> N° de OT:</b> {{ remitos.numot }}</h6>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <h6>Código Registro: {{ remitos.codgral }}</h6>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="4" md="4">
              <h6>Recepcionó: {{ remitos.recepciono }}</h6>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <h6>Fecha: {{ remitos.fecha }}</h6>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <h6>Lugar: {{ remitos.lugar }}</h6>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="4" md="4">
              <h6>Transporte: {{ remitos.transporte }}</h6>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <h6>Remito: {{ remitos.remito }}</h6>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <h6>Proveedor: {{ remitos.proveedor }}</h6>
              <h6>N.P.: {{ remitos.notapedido }}</h6>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card height="100%">
        <v-data-table
          dense
          :headers="headers"
          :items="remitos.listadomateriales"
          locale="es-ar"
          class="elevation-1"
          :items-per-page="50"
          :footer-props="{
            itemsPerPageText: 'Items por página',
          }"
        >
        </v-data-table>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import axios from "../../../src/axios-auth";
export default {
  data: (vm) => ({
    valid: false,
    lazy: false,
    numot: "",
    codgral: "",
    notapedido: "",
    remito: "",
    proveedor: "",
    lugar: "",
    transporte: "",
    recepciono: "",
    fecha: "",
    remitos: [],
    headers: [
      {
        text: "Item",
        align: "center",
        sortable: false,
        value: "item",
      },
      { text: "OT", align: "center", value: "otrabajo", sortable: false },
      { text: "Detalle", value: "descr", width: "30%", sortable: false },
      { text: "Unidad", align: "center", value: "unidad", sortable: false },
      { text: "Cantidad", align: "center", value: "cantidad", sortable: false },
      { text: "Clase A", value: "claseA", sortable: false },
      { text: "Observac.", value: "observ", width: "5%", sortable: false },
    ],
  }),

  props: ["visible", "codigo"],

  computed: {
    show: {
      get() {
        this.cargarRemito();
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.vaciarInforme();
          console.log("cerrado");
          this.$refs.form.resetValidation();
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.$emit("close");
        }
      },
    },
  },

  methods: {
    cargarRemito() {
      let self = this;
      axios
        .get("/Obras/GetInformeRemito?", {
          params: {
            codigo: self.codigo,
          },
        })
        .then((response) => {
          self.remitos = response.data;
        })
        .catch((error) => {
          self.remitos = [];
          console.log(error);
        });
    },

    vaciarInforme() {
      this.remitos = [];
    },
  },
};
</script>
